<template>
  <ul class="topnav">
    <li>
      <router-link to="/Index">
        <div class="menutext">推荐</div>
      </router-link>
    </li>
    <li>
      <router-link to="/zhanlan">
        <div class="menutext">展览</div>
      </router-link>
    </li>
    <!-- <li>
      <router-link to="/news">
        <div class="menutext">资讯</div>
      </router-link>
    </li> -->
    <li>
      <router-link to="/activity">
        <div class="menutext">活动</div>
      </router-link>
    </li>
  </ul>
</template>

<script>
	export default {
		data () {
		    return {

		    }
		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="scss" scoped="">
   .topnav{
      background-color: #ffffff;
      color: #333333;
      height: 2.25rem;
      line-height: 2.25rem;
      width: 100%;
      margin-bottom: 0.5rem;

      display:flex;
      justify-content: space-around;
      padding: 0;
      list-style: none;
      li{

          .menutext{
            font-size: 0.8rem;
            color: #333333;
          }
      }
      .router-link-active{
          .menutext{
            background: url("../assets/Line.png") no-repeat center bottom;
            font-weight: bold;

          }
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/topnav.vue